export default "__VITE_ASSET__D5Neu3wV__"